import { gql } from "@apollo/client";

export const groupsSearch = gql`
  query groupsManagerData(
    $scenarioId: ID!
    $originId: ID!
    $filter: GroupsManagerSearchFilterInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      groupsManagerSearch(filter: $filter) {
        items {
          capacity
          clientCode
          code
          enrollmentsCount
          id
          isActive
          label
          utilization
          visibleForEnrollment
          isReferent
          referentType
          enrollmentStats {
            capacity
            usedCapacity
            enrollmentsCount
            waitingListsCount
          }
          links {
            id
            vacancies
          }
          labels {
            id
            code
            name
          }
          externalStats {
            capacity
            bookingCount
            enrollmentCount
            usedCapacity
            waitingListCount
            updatedAt
          }
          campus {
            id
            name
            code
          }
          course {
            id
            code
            name
            tags
          }
          term {
            id
            code
            name
          }
          primaryInstructor {
            id
            code
            name
          }
          groupCapacity {
            id
            calculatedCapacity
            calculatedCapacityReason
            configMinCapacity
            configMaxCapacity
            effectiveMinCapacity
            effectiveMaxCapacity
            defaultCapacityPercentage
            calculatedConfigMinCapacity
            calculatedConfigMaxCapacity
          }
          isEditable {
            allowed
            reason
          }
          curriculum {
            id
            code
            program {
              id
              code
              department {
                id
                code
              }
              modality {
                id
                code
                name
              }
              shift {
                id
                code
              }
            }
          }
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
        __typename
      }
      __typename
    }
  }
`;

export const shortGroupsSearch = gql`
  query shortGroupsSearch(
    $scenarioId: ID!
    $originId: ID!
    $filter: GroupsManagerSearchFilterInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      groupsManagerSearch(filter: $filter) {
        items {
          id
          capacity
          referentType
          curriculum {
            id
            code
            program {
              id
              code
              department {
                id
                code
              }
              modality {
                id
                code
                name
              }
              shift {
                id
                code
              }
            }
          }
          campus {
            id
            name
            code
          }
          externalStats {
            capacity
            bookingCount
            enrollmentCount
            usedCapacity
            waitingListCount
            updatedAt
          }
          enrollmentStats {
            capacity
            usedCapacity
            enrollmentsCount
            waitingListsCount
          }
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
        __typename
      }
      __typename
    }
  }
`;
